import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as ComputeVatGenericError } from "./types/ComputeVat/ComputeVatError";
import { InvalidParameterError as ComputeVatInvalidParameterError } from "./types/ComputeVat/ComputeVatError";
import { UnauthorizedError as ComputeVatUnauthorizedError } from "./types/ComputeVat/ComputeVatError";
import { NotFoundError as ComputeVatNotFoundError } from "./types/ComputeVat/ComputeVatError";
import { InternalServerError as ComputeVatInternalServerError } from "./types/ComputeVat/ComputeVatError";
import { BadGatewayError as ComputeVatBadGatewayError } from "./types/ComputeVat/ComputeVatError";
import { GatewayTimeoutError as ComputeVatGatewayTimeoutError } from "./types/ComputeVat/ComputeVatError";
import { GenericError as ListCountriesGenericError } from "./types/ListCountries/ListCountriesError";
import { UnauthorizedError as ListCountriesUnauthorizedError } from "./types/ListCountries/ListCountriesError";
import { InternalServerError as ListCountriesInternalServerError } from "./types/ListCountries/ListCountriesError";
import { BadGatewayError as ListCountriesBadGatewayError } from "./types/ListCountries/ListCountriesError";
import { GatewayTimeoutError as ListCountriesGatewayTimeoutError } from "./types/ListCountries/ListCountriesError";
import { GenericError as VerifyVatNumberGenericError } from "./types/VerifyVatNumber/VerifyVatNumberError";
import { InvalidParameterError as VerifyVatNumberInvalidParameterError } from "./types/VerifyVatNumber/VerifyVatNumberError";
import { UnauthorizedError as VerifyVatNumberUnauthorizedError } from "./types/VerifyVatNumber/VerifyVatNumberError";
import { NotFoundError as VerifyVatNumberNotFoundError } from "./types/VerifyVatNumber/VerifyVatNumberError";
import { InternalServerError as VerifyVatNumberInternalServerError } from "./types/VerifyVatNumber/VerifyVatNumberError";
import { BadGatewayError as VerifyVatNumberBadGatewayError } from "./types/VerifyVatNumber/VerifyVatNumberError";
import { GatewayTimeoutError as VerifyVatNumberGatewayTimeoutError } from "./types/VerifyVatNumber/VerifyVatNumberError";
export const errors = {
    ComputeVat: {
        InvalidParameterError: ComputeVatInvalidParameterError,
        UnauthorizedError: ComputeVatUnauthorizedError,
        NotFoundError: ComputeVatNotFoundError,
        InternalServerError: ComputeVatInternalServerError,
        BadGatewayError: ComputeVatBadGatewayError,
        GatewayTimeoutError: ComputeVatGatewayTimeoutError,
        GenericError: ComputeVatGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListCountries: {
        UnauthorizedError: ListCountriesUnauthorizedError,
        InternalServerError: ListCountriesInternalServerError,
        BadGatewayError: ListCountriesBadGatewayError,
        GatewayTimeoutError: ListCountriesGatewayTimeoutError,
        GenericError: ListCountriesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyVatNumber: {
        InvalidParameterError: VerifyVatNumberInvalidParameterError,
        UnauthorizedError: VerifyVatNumberUnauthorizedError,
        NotFoundError: VerifyVatNumberNotFoundError,
        InternalServerError: VerifyVatNumberInternalServerError,
        BadGatewayError: VerifyVatNumberBadGatewayError,
        GatewayTimeoutError: VerifyVatNumberGatewayTimeoutError,
        GenericError: VerifyVatNumberGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ComputeVatError: {
        InvalidParameterError: ComputeVatInvalidParameterError,
        UnauthorizedError: ComputeVatUnauthorizedError,
        NotFoundError: ComputeVatNotFoundError,
        InternalServerError: ComputeVatInternalServerError,
        BadGatewayError: ComputeVatBadGatewayError,
        GatewayTimeoutError: ComputeVatGatewayTimeoutError,
        GenericError: ComputeVatGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListCountriesError: {
        UnauthorizedError: ListCountriesUnauthorizedError,
        InternalServerError: ListCountriesInternalServerError,
        BadGatewayError: ListCountriesBadGatewayError,
        GatewayTimeoutError: ListCountriesGatewayTimeoutError,
        GenericError: ListCountriesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    VerifyVatNumberError: {
        InvalidParameterError: VerifyVatNumberInvalidParameterError,
        UnauthorizedError: VerifyVatNumberUnauthorizedError,
        NotFoundError: VerifyVatNumberNotFoundError,
        InternalServerError: VerifyVatNumberInternalServerError,
        BadGatewayError: VerifyVatNumberBadGatewayError,
        GatewayTimeoutError: VerifyVatNumberGatewayTimeoutError,
        GenericError: VerifyVatNumberGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
